export default __webpack_public_path__ + "static/media/dot-fill.14becd29.svg";